import { PROPERTY_TYPES } from "./types";
import { SC, SCA, SCI, SCN } from "./condominiumActions";
import { Toast } from "./../components/UI/toast/Toast";

/**
 * HO-HU-37: elegir cual de las propiedades de la cuenta queda activa.
 * Ademas de guardar la property elegida, despacha los mismos 4 datos de
 * condominio que ya usa el selector de condominio del manager
 * (condominiumActions.SelectCondominium) -- todo el resto del sistema que
 * ya depende de state.condominium.selectedCondominium (findConfigAsProperty,
 * Feed, etc.) sigue funcionando igual sin que haya que tocarlo.
 */
export const SelectProperty = (property) => async (dispatch) => {
  dispatch({
    type: PROPERTY_TYPES.SELECT_PROPERTY,
    payload: { id: property.id, label: property.property },
  });
  dispatch(SC(property.condominiumId));
  dispatch(SCN(property.condominiumName));
  dispatch(SCA(property.condominiumAddress));
  dispatch(SCI(property.condominiumIdentification));
  Toast.fire({
    type: "info",
    title: "Has seleccionado una propiedad.",
  });
};

export const UnselectProperty = () => async (dispatch) => {
  dispatch({ type: PROPERTY_TYPES.UNSELECT_PROPERTY });
};

/**
 * HO-ISSUE-119: al renombrar el inmueble desde "Mi perfil", el navbar seguia
 * mostrando el nombre viejo -- uno que ya no existe -- hasta recargar la
 * pagina o volver a elegir propiedad. No usa SelectProperty porque esto no es
 * un cambio de propiedad: la seleccionada es la misma y no corresponde ni el
 * aviso ni volver a despachar el condominio.
 */
export const RenameSelectedProperty = (label) => async (dispatch) => {
  dispatch({
    type: PROPERTY_TYPES.RENAME_SELECTED_PROPERTY,
    payload: { label },
  });
};
